<template>
  <div id="manual">
    <a-modal
      v-model="visible"
      :title="$t('manual.Manual')"
      width="90%"
      :maskClosable="maskClosable"
      @cancel="cancelManual"
    >
      <template slot="footer">
        <a-button type="primary" @click="soPick(0)">{{ $t('manual.New') }}</a-button>
        <a-button type="primary" @click="soPick(1)">{{ $t('manual.AddToPick') }}</a-button>
        <a-button type="primary">{{ $t('manual.Unpick') }}</a-button>
      </template>
      <div>
        <vxe-table
          ref="partTableManual"
          stripe
          border
          highlight-hover-row
          resizable
          size="mini"
          :loading="partLoading"
          :data.sync="tableData"
          class="mytable-style"
          @cell-click="cellClickEvent"
          :cell-class-name="cellClassName"
        >
          <vxe-table-column
            show-header-overflow="ellipsis" show-overflow="ellipsis"
            field="soNo"
            :title="$t('manual.SO')"
          ></vxe-table-column>
          <vxe-table-column
            show-header-overflow="ellipsis" show-overflow="ellipsis"
            field="sku"
            :title="$t('manual.Sku')"
          ></vxe-table-column>
          <vxe-table-column
            show-header-overflow="ellipsis" show-overflow="ellipsis"
            field="recId"
            :title="$t('manual.RecID')"
          ></vxe-table-column>
          <vxe-table-column
            show-header-overflow="ellipsis" show-overflow="ellipsis"
            field="batchNo"
            :title="$t('manual.BatchNo')"
          ></vxe-table-column>
          <vxe-table-column
            show-header-overflow="ellipsis" show-overflow="ellipsis"
            field="soDate"
            :title="$t('manual.SODate')"
          >
            <template v-slot="{ row }">
              <span>{{ row.soDate | filterDate }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column
                  show-header-overflow="ellipsis" show-overflow="ellipsis"
            :label="$t('manual.AllQty')"
          >
            <template v-slot="{ row }">
              <span>{{ row.allQty }}/{{ row.soQty }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column
            show-header-overflow="ellipsis" show-overflow="ellipsis"
            field="locationCode"
            :title="$t('manual.AllocateLocation')"
          ></vxe-table-column>
          <vxe-table-column
            show-header-overflow
            show-overflow
            field="status"
            :title="$t('manual.Status')"
          ></vxe-table-column>
        </vxe-table>
        <hr />
        <vxe-table
          ref="subTableManual"
          stripe
          border
          highlight-hover-row
          resizable
          size="mini"
          class="subClassName"
          :data.sync="subTableData"
          :loading="subLoading"
          @select-change="checkboxChange"
          v-if="subTableFlag"
          :select-config="{ labelField: 'checkFlag', checkMethod }"
        >
          <vxe-table-column
            type="checkbox"
            width="60"
          ></vxe-table-column>
          <vxe-table-column
            show-header-overflow="ellipsis" show-overflow="ellipsis"
            field="lotId"
            :title="$t('manual.LotID')"
          ></vxe-table-column>
          <vxe-table-column
            show-header-overflow="ellipsis" show-overflow="ellipsis"
            field="sku"
            :title="$t('manual.Sku')"
          ></vxe-table-column>
          <vxe-table-column
            show-header-overflow="ellipsis" show-overflow="ellipsis"
            field="recId"
            :title="$t('manual.RecID')"
          ></vxe-table-column>
          <vxe-table-column
            show-header-overflow="ellipsis" show-overflow="ellipsis"
            field="batchNo"
            :title="$t('manual.BatchNo')"
          ></vxe-table-column>
          <vxe-table-column
            show-header-overflow="ellipsis" show-overflow="ellipsis"
            field="recDate"
            :label="$t('manual.RecDate')"
          >
            <template v-slot="{ row }">
              <span>{{ row.recDate | filterDate }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column
            show-header-overflow="ellipsis" show-overflow="ellipsis"
            field="recQty"
            :title="$t('manual.RecQty')"
          ></vxe-table-column>
          <vxe-table-column
            show-header-overflow="ellipsis" show-overflow="ellipsis"
            field="availableQty"
            :title="$t('manual.AvailableQty')"
          ></vxe-table-column>
          <vxe-table-column
            show-header-overflow
            show-overflow
            field="allocateQty"
            :title="$t('manual.AllocateQty')"
          ></vxe-table-column>
          <vxe-table-column
            show-header-overflow="ellipsis" show-overflow="ellipsis"
            field="shippedQty"
            :title="$t('manual.ShippedQty')"
          ></vxe-table-column>
          <vxe-table-column
            show-header-overflow="ellipsis" show-overflow="ellipsis"
            field="locationCode"
            :title="$t('pubGicSet.Location')"
          ></vxe-table-column>
          <vxe-table-column
            show-header-overflow="ellipsis" show-overflow="ellipsis"
            field="manufactureDate"
            :title="$t('manual.MANUFACTUREDate')"
          >
            <template v-slot="{ row }">
              <span>{{ row.manufactureDate | filterDate }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column
            show-header-overflow="ellipsis" show-overflow="ellipsis"
            field="exporyDate"
            :title="$t('manual.EXPIRYDate')"
          >
            <template v-slot="{ row }">
              <span>{{ row.exporyDate | filterDate }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column
            show-header-overflow="ellipsis" show-overflow="ellipsis"
            field="shelfDate"
            :title="$t('manual.SHELFDate')"
          >
            <template v-slot="{ row }">
              <span>{{ row.shelfDate | filterDate }}</span>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </a-modal>
  </div>
</template>
<script>
import ajax from "../../api/ajax";
import api from "../../api/url";
import monent from "moment";
export default {
  props: {
    manualParams: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      visible: false,
      tableData: [],
      parTableSelect: null,
      subTableData: [],
      subTableFlag: false,
      maskClosable: false, // 关闭遮罩
      subLoading: false,
      partLoading: false,
      firstConfirm: 0,
      subSelectArr: [],
      pickHeaderUid: ""
    };
  },
  watch: {
    visible(val) {
      this.initData();
    }
  },
  filters: {
    filterDate(val) {
      return monent(val).format("YYYY-MM-DD");
    }
  },
  methods: {
    cancelManual() {
      this.subTableData = [];
      this.firstConfirm = 0;
    },
    checkMethod({ row }) {
      return row.checkFlag;
    },
    closeModal() {
      this.visible = false;
    },
    openModal() {
      this.visible = true;
    },
    //         part table data
    initData() {
      this.partLoading = true;
      ajax.post(api.OUTSTANDINGDETAIL, this.manualParams).then(res => {
        this.partLoading = false;
        this.tableData = res.data;
        for (let ii in this.tableData) {
          this.tableData[ii].original = this.tableData[ii].allQty;
        }
      });
    },
    //         par 点击当前class
    cellClassName({ row }) {
      if (row === this.parTableSelect) {
        return "col-orange";
      }
    },
    //         点击父表格请求详情sub
    cellClickEventFn() {
      let params = {
        orgCode: this.parTableSelect.orgCode,
        projectCode: this.parTableSelect.projectCode,
        sku: this.parTableSelect.sku,
        warehouseCode: this.parTableSelect.warehouseCode,
        logicalWh: this.parTableSelect.logicalWh,
        uid: this.parTableSelect.uid
      };
      ajax.post(api.SOBANABCE, params).then(res => {
        this.firstConfirm = this.firstConfirm + 1;
        this.subLoading = false;
        this.subTableData = res.data;
        for (let ii in this.subTableData) {
          this.subTableData[ii].checkVal = 0;
          this.subTableData[ii].checkFlag = true;
        }
      });
    },
    cellClickEvent({ row }) {
      //             记录之前数据
      let that = this;
      //            第一次进来不需要提示这个
      if (this.firstConfirm != 0) {
        this.$customConfirm({
          title: this.$t('publicLang.prompt'),
          content: "",
          onOk() {
            that.subLoading = true;
            that.parTableSelect = row;
            for (let ii in that.tableData) {
              that.tableData[ii].allQty = that.tableData[ii].original;
            }
            that.cellClickEventFn();
          }
        });
      } else {
        this.subTableFlag = true;
        this.subLoading = true;
        this.parTableSelect = row;
        this.cellClickEventFn();
      }
    },
    checkboxChange(val) {
      this.subSelectArr = val.selection;
      let checkType = val.checked;
      let partNum = this.parTableSelect;
      let partData = this.tableData;
      let subData = this.subTableData;
      let checkArr = val.row.availableQty;
      for (let ii in partData) {
        if (checkType) {
          if (this.parTableSelect.uid == partData[ii].uid) {
            if (partData[ii].allQty + checkArr < partData[ii].soQty) {
              partData[ii].allQty = partData[ii].allQty + checkArr;
              for (let jj in subData) {
                if (subData[jj].uid == val.row.uid) {
                  subData[jj].checkVal = subData[jj].availableQty;
                  subData[jj].allocateQty =
                    subData[jj].allocateQty + subData[jj].availableQty;
                  subData[jj].availableQty = 0;
                }
              }
            } else {
              if (partData[ii].allQty < partData[ii].soQty) {
                //                                 还可以添加数量
                let tt = partData[ii].soQty - partData[ii].allQty;
                let cc = checkArr - (checkArr - tt);
                partData[ii].allQty = partData[ii].allQty + cc;
                for (let jj in subData) {
                  if (subData[jj].uid == val.row.uid) {
                    subData[jj].checkVal = cc;
                    subData[jj].allocateQty = subData[jj].allocateQty + cc;
                    subData[jj].availableQty = subData[jj].availableQty - cc;
                  }
                }

                if (partData[ii].allQty == partData[ii].soQty) {
                  for (let kk in subData) {
                    if (subData[kk].checkVal != 0) {
                      subData[kk].checkFlag = true;
                    } else {
                      subData[kk].checkFlag = false;
                    }
                  }
                }
              } else {
                return;
              }
            }
          }
        } else {
          if (this.parTableSelect.uid == partData[ii].uid) {
            for (let jj in subData) {
              subData[jj].checkFlag = true;
              if (subData[jj].uid == val.row.uid) {
                partData[ii].allQty =
                  partData[ii].allQty - subData[jj].checkVal;
                subData[jj].availableQty =
                  subData[jj].availableQty + subData[jj].checkVal;
                subData[jj].allocateQty =
                  subData[jj].allocateQty - subData[jj].checkVal;
              }
            }
          }
        }
      }
    },
    soPick(val) {
      if (this.subSelectArr.length < 1) {
        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
        return;
      }
      for (let k in this.parTableSelect) {
        if (k == "original") {
          delete this.parTableSelect[k];
        }
      }
      let params = {
        bntNum: val,
        pickHeaderUid: this.pickHeaderUid,
        invBalVoList: this.subSelectArr,
        soDetailVo: this.parTableSelect
      };
      ajax.post(api.SOPICK, params).then(res => {
        if (res.code == 200) {
          this.pickHeaderUid = res.data.pickHeaderUid;
          this.$message.success(this.$t('manual.NewpickPleasego'));
        } else {
          this.$customMessage.warning(res.msg);
        }
      });
    }
  }
};
</script>
<style>
.vxe-table--filter-wrapper {
  z-index: 50000 !important;
}
.subClassName
  > .vxe-table--header-wrapper
  > table
  > thead
  > tr
  > th:first-child
  .vxe-cell {
  display: none;
}
</style>
